"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketField = exports.TicketFieldControl = exports.TicketBookableStatus = void 0;
var TicketBookableStatus;
(function (TicketBookableStatus) {
    TicketBookableStatus[TicketBookableStatus["Available"] = 0] = "Available";
    TicketBookableStatus[TicketBookableStatus["SoldOut"] = 1] = "SoldOut";
    TicketBookableStatus[TicketBookableStatus["CurrentlyUnavailable"] = 2] = "CurrentlyUnavailable";
    TicketBookableStatus[TicketBookableStatus["AvailableWithOtherTicketType"] = 3] = "AvailableWithOtherTicketType";
    TicketBookableStatus[TicketBookableStatus["MaximumTicketNumberReached"] = 4] = "MaximumTicketNumberReached";
    TicketBookableStatus[TicketBookableStatus["TicketTypeNotActive"] = 5] = "TicketTypeNotActive";
})(TicketBookableStatus = exports.TicketBookableStatus || (exports.TicketBookableStatus = {}));
var TicketFieldControl;
(function (TicketFieldControl) {
    TicketFieldControl[TicketFieldControl["RadioButtonList"] = 0] = "RadioButtonList";
    TicketFieldControl[TicketFieldControl["CheckboxList"] = 1] = "CheckboxList";
    TicketFieldControl[TicketFieldControl["Dropdown"] = 2] = "Dropdown";
    TicketFieldControl[TicketFieldControl["Textbox"] = 3] = "Textbox";
    TicketFieldControl[TicketFieldControl["MultilineTextbox"] = 4] = "MultilineTextbox";
    TicketFieldControl[TicketFieldControl["EmailTextbox"] = 5] = "EmailTextbox";
    TicketFieldControl[TicketFieldControl["TelephoneNumberTextbox"] = 6] = "TelephoneNumberTextbox";
    TicketFieldControl[TicketFieldControl["TextLabelTextLabel"] = 7] = "TextLabelTextLabel";
})(TicketFieldControl = exports.TicketFieldControl || (exports.TicketFieldControl = {}));
var TicketField;
(function (TicketField) {
    TicketField[TicketField["Salutation"] = 0] = "Salutation";
    TicketField[TicketField["FirstName"] = 1] = "FirstName";
    TicketField[TicketField["LastName"] = 2] = "LastName";
    TicketField[TicketField["Company"] = 3] = "Company";
    TicketField[TicketField["BirthDate"] = 4] = "BirthDate";
    TicketField[TicketField["Street"] = 5] = "Street";
    TicketField[TicketField["City"] = 6] = "City";
    TicketField[TicketField["PostCode"] = 7] = "PostCode";
    TicketField[TicketField["Phone"] = 8] = "Phone";
    TicketField[TicketField["Email"] = 9] = "Email";
    TicketField[TicketField["Option1"] = 10] = "Option1";
    TicketField[TicketField["Option2"] = 11] = "Option2";
    TicketField[TicketField["Option3"] = 12] = "Option3";
    TicketField[TicketField["Option4"] = 13] = "Option4";
    TicketField[TicketField["Option5"] = 14] = "Option5";
    TicketField[TicketField["Option6"] = 15] = "Option6";
    TicketField[TicketField["Option7"] = 16] = "Option7";
    TicketField[TicketField["Option8"] = 17] = "Option8";
    TicketField[TicketField["Option9"] = 18] = "Option9";
    TicketField[TicketField["Option10"] = 19] = "Option10";
    TicketField[TicketField["Option11"] = 20] = "Option11";
    TicketField[TicketField["Option12"] = 21] = "Option12";
    TicketField[TicketField["Option13"] = 22] = "Option13";
    TicketField[TicketField["Option14"] = 23] = "Option14";
    TicketField[TicketField["Option15"] = 24] = "Option15";
    TicketField[TicketField["Option16"] = 25] = "Option16";
    TicketField[TicketField["Option17"] = 26] = "Option17";
    TicketField[TicketField["Option18"] = 27] = "Option18";
    TicketField[TicketField["Option19"] = 28] = "Option19";
    TicketField[TicketField["Option20"] = 29] = "Option20";
})(TicketField = exports.TicketField || (exports.TicketField = {}));
